<template>
  <div class="home">
    <NotFound v-if="$store.state.errorFlag"></NotFound>
    <template v-else>
      <Locale></Locale>
      <ListMenu></ListMenu>
      <Footer></Footer>
    </template>
  </div>
</template>

<script>
// @ is an alias to /src
import NotFound from "@/views/NotFound";
import Locale from "@/components/Locale";
import ListMenu from "@/components/ListMenu";
import Footer from "@/components/Footer";

export default {
  name: "Home",
  components: {
    Locale,
    ListMenu,
    NotFound,
    Footer,
  },
  created: function () {
    this.$store.dispatch("createCategories", { id: this.$route.query.id });
    this.$store.dispatch("createPosts", { id: this.$route.query.id });
  },
};
</script>

<style>
ul {
  list-style: none;
}
</style>
